<ng-container stagesSlot="main"></ng-container>
